import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/articles";

export default function CategoryNav() {
  const { t } = useTranslation("home");

  const categoryImages: Record<string, string> = {
    "cat-dasai": "https://readdy.ai/api/search-image?query=Chinese%20internet%20celebrity%20livestreaming%20reality%20show%20scene%20with%20dramatic%20red%20and%20gold%20lighting%2C%20behind%20the%20scenes%20documentary%20style%2C%20warm%20atmospheric%20tones%2C%20emotional%20reaction%20moment%2C%20cinematic%20composition%2C%20dark%20background%20with%20spotlight%20on%20subject&width=800&height=1000&seq=cat-dasai&orientation=portrait",
    "cat-bagua": "https://readdy.ai/api/search-image?query=Chinese%20celebrity%20red%20carpet%20event%20night%20scene%20with%20flashing%20paparazzi%20cameras%2C%20luxurious%20atmosphere%20with%20warm%20golden%20and%20crimson%20tones%2C%20glamorous%20entertainment%20industry%20vibe%2C%20editorial%20photography%20style%2C%20soft%20bokeh%20background&width=800&height=600&seq=cat-bagua&orientation=landscape",
    "cat-heiliao": "https://readdy.ai/api/search-image?query=mysterious%20investigative%20journalism%20scene%20with%20documents%20and%20magnifying%20glass%20on%20dark%20desk%2C%20dramatic%20warm%20crimson%20and%20deep%20shadow%20lighting%2C%20noir%20detective%20aesthetic%2C%20cinematic%20composition%2C%20high%20contrast%20atmosphere&width=800&height=600&seq=cat-heiliao&orientation=landscape",
    "cat-chigua": "https://readdy.ai/api/search-image?query=colorful%20social%20media%20feed%20collage%20with%20dramatic%20contrast%20elements%2C%20split%20screen%20showing%20different%20perspectives%2C%20warm%20red%20and%20teal%20accent%20tones%2C%20modern%20digital%20culture%20aesthetic%2C%20dynamic%20editorial%20composition%2C%20entertainment%20media%20style&width=800&height=600&seq=cat-chigua&orientation=landscape",
  };

  const colorClasses: Record<string, string> = {
    primary: "bg-primary-500",
    accent: "bg-accent-500",
    secondary: "bg-secondary-500",
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-900 tracking-tight">
            {t("categoryNav.title1")}
            <span className="text-secondary-500"> {t("categoryNav.highlight")} </span>
            {t("categoryNav.title2")}
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-4">
          {categories.slice(0, 1).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="lg:w-1/2 relative rounded-lg overflow-hidden group cursor-pointer h-64 lg:h-auto"
            >
              <img
                src={categoryImages[cat.imageSeq] || categoryImages["cat-dasai"]}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className={`inline-block px-2 py-1 text-xs font-label text-background-50 rounded-full whitespace-nowrap ${colorClasses[cat.color] || colorClasses.primary}`}>
                  {cat.name}
                </span>
                <p className="mt-2 text-sm text-background-50/80 leading-relaxed">{cat.description}</p>
              </div>
            </Link>
          ))}

          <div className="lg:w-1/2 flex flex-col gap-4">
            {categories.slice(1).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="relative rounded-lg overflow-hidden group cursor-pointer h-36 md:h-44"
              >
                <img
                  src={categoryImages[cat.imageSeq] || categoryImages["cat-bagua"]}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4 flex items-center gap-3">
                  <span className={`w-10 h-10 flex items-center justify-center rounded-full text-background-50 ${colorClasses[cat.color] || colorClasses.secondary}`}>
                    <i className={`${cat.icon} text-lg`}></i>
                  </span>
                  <div>
                    <span className="text-sm font-label font-medium text-background-50">{cat.name}</span>
                    <p className="text-xs text-background-50/70 mt-0.5">{cat.description}</p>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}